import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

// import modules this module depends on
import angularTranslate from 'angular-translate';
// import rnDevice from 'rhino/src/components/device/device.module';
// import rnSession from 'rhino/src/components/session/session.module';
// import rnHttp from 'rhino/src/core/http/http.module';
// import rnPreferences from 'rhino/src/components/preferences/preferences.module';
import * as acceptUser from './accept-user.controller';
import gzEula from 'gazelle/src/components/user/eula/eula.module';
import gzHpId from 'gazelle/src/components/hpid/hpid.module';

// import this modules components

import './accept-user.scss';

// define the module in one place and export the module name
export default angular.module('register.components.acceptuser', [
  gzEula,
  uiRouter,
  ngMaterial,
  angularTranslate,
  gzHpId,
  'rhino.components.locale',
  'rhino.components.preferences',
  'rhino.components.invitation',
  'rhino.components.session',
  'rhino.core',
  'angulartics'
])
  .controller(acceptUser.name, acceptUser.default)
  .name;



// WEBPACK FOOTER //
// ./components/accept/user/accept-user.module.js